import { classNames } from 'primereact/utils'
import { MenubarPassThroughOptions } from 'primereact/menubar'

export const menubarConfig: MenubarPassThroughOptions = {
  root: {
    className: 'flex items-center relative',
  },
  menu: ({ state }: { state: any }) => ({
    className: classNames(
      'm-0 md:p-0 list-none',
      'outline-none',
      // 'sm:flex items-center flex-wrap sm:flex-row sm:top-auto sm:left-auto sm:relative sm:bg-transparent sm:shadow-none sm:w-auto',
      'md:flex items-center flex-nowrap md:flex-row md:top-auto md:left-auto md:relative md:bg-transparent md:shadow-none md:w-auto',
      'flex-col top-full left-0',
      // 'absolute py-1 bg-white dark:bg-gray-900 border-0 shadow-md w-full',
      'absolute border-0 md:w-full',
      {
        'hidden ': !state?.mobileActive,
        'flex ': state?.mobileActive,
      },
    ),
  }),
  menuitem: () => ({
    className: classNames('md:relative md:w-auto w-full static', 'transition-shadow duration-200'),
  }),
  action: ({ context }: { context: any }) => ({
    className: classNames('select-none', 'cursor-pointer flex items-center no-underline overflow-hidden relative', 'py-3 px-5 select-none', {
      'pl-9 sm:pl-5': context.level === 1,
      'pl-14 sm:pl-5': context.level === 2,
    }),
  }),
  icon: {
    className: 'mr-2',
  },
  submenuIcon: (options) => ({
    className: classNames({
      'ml-auto sm:ml-2': options?.props,
      'ml-auto': !options?.props,
    }),
  }),
  submenu: () => ({
    className: classNames('md:bg-white dark:bg-gray-900 border-0  sm:shadow-md lg:w-56', 'w-full static shadow-none', 'md:absolute z-10', 'm-0 list-none', {}),
  }),
  separator: {
    className: 'border-t border-gray-300 dark:border-blue-900/40 my-1',
  },
  button: {
    className: classNames(
      'flex md:hidden text-white dark:text-white/80 transition duration-200 ease-in-out',
      'cursor-pointer flex items-center justify-center no-underline',
      'dark:hover:text-white/80 dark:hover:bg-gray-800/80 ',
      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
    ),
  },
}
